// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__9b8r5","balanceDisclaimer":"posDashboard_balanceDisclaimer__DedTv"};